import type { useForm } from "hooks";
import type { BootstrapableForm, Option } from "types";
import type { BankingSdkConnector } from "features/openBanking/types";
import { BankingFormField } from '../shared';

export const FormField = {
    ...BankingFormField,
    AisOptions: 'aisOptions',
    CountryIso: 'countryISO',
    Flow: 'flow',
    IsEnabled: 'isEnabled',
    Obs: 'obs',
    OrderNo: 'orderNo',
    PisOptions: 'pisOptions',
    ShouldCreditOnRedirect: 'shouldCreditOnRedirect',
    Status: 'status',
} as const;

export type BankingSDK = {
    readonly [FormField.AisOptions]: object;
    readonly [FormField.PisOptions]: object;
    readonly [FormField.CountryIso]: Array<string>;
    readonly [FormField.Flow]: Option | null;
} & Pick<
    BankingSdkConnector,
    | 'bankGroup'
    | 'bankId'
    | 'fullName'
    | 'isEnabled'
    | 'recipients_exist'
    | 'logoUrl'
    | 'obs'
    | 'orderNo'
    | 'shouldCreditOnRedirect'
    | 'status'
>;

export type BootstrapData = {
    readonly ConnectorsFlows: Array<Option>;
    readonly OpenBankingLogosDomain: string;
};

export type BankingSDKForm = Omit<
    BootstrapableForm<BankingSDK, BootstrapData>,
    | 'initialValues'
> & {
    readonly initialValues: BankingSDK;
};

export type BankingSDKProps =
    & BankingSDKForm
    & ReturnType<typeof useForm<BankingSDK>>;
